import { localisedValue } from "utils"

export default function fractionalProjectsTransformer(response) {
  if (response?.length) {
    return response?.map(p => {
      const project = p?.Project ?? p?.project
      return {
        id: p?.projectId,
        label: localisedValue({ object: p, key: "name" }),
        value: p?.projectId?.toString(),
        paymentProof: p?.paymentProof ?? p?.payment_proof ?? project?.paymentProof ?? project?.payment_proof,
        isRAFlowEnabled: p?.isRAFlowEnabled ?? p?.is_ra_flow_enabled ?? project?.isRAFlowEnabled,
      }
    })
  }
}
